import React, { Component } from 'react';
import Dropdown from '../../Part_Sample/Dropdown';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Editbox from '../../Part_Sample/Editbox';
import { isEmpty } from '../../Common/Common';
import Select from '../../Part_Sample/Select';

export default class Add_Edit_IAQ_Devices extends Component {
	constructor(props) {
		super(props);

		////////////////////////
		// this.props.param.iaq_settings 								(whole data store)
		// this.props.param.room_id										(current selected room name)
		// this.props.param.iaq_settings[this.props.param.room_id]		(just device settings for current room)
		// this.props.param.selected_iaq_settings_index 				(Index of the selected iaq_settings in device settings.
		////////////////////////

		let selected_iaq_device = {
			id: '',
			type: 'co2',
			threshold_yellow: 0,
			threshold_red: 0,
		};

		if (this.props.param.selected_iaq_settings_index != null) {
			selected_iaq_device = this.props.param.iaq_settings[this.props.param.room_id][this.props.param.selected_iaq_settings_index];
		}

		this.state = {
			selected_iaq_device: selected_iaq_device
		}

		window.app.hideLoading();
	}

	handlePrevious = () => {
		this.props.content_handler('Add_Edit_IAQ', { room_id: this.props.param.room_id, iaq_settings: this.props.param.iaq_settings });
	}

	handleRegister = () => {
		if (this.state.selected_iaq_device.id == '') {
			window.app.showToast(this.props.receiver.getString('sel_device'), 3000);
			return;
		}

		let tempPayload = JSON.parse(JSON.stringify(this.props.param.iaq_settings));

		let tempIAQDevice = JSON.parse(JSON.stringify(this.state.selected_iaq_device));

		if (tempIAQDevice.threshold_yellow == '') {
			tempIAQDevice.threshold_yellow = 0;
		} else {
			tempIAQDevice.threshold_yellow = parseInt(tempIAQDevice.threshold_yellow);
		}

		if (tempIAQDevice.threshold_red == '') {
			tempIAQDevice.threshold_red = 0;
		} else {
			tempIAQDevice.threshold_red = parseInt(tempIAQDevice.threshold_red);
		}

		//Added threshold red/ threshold yellow check
		if(tempIAQDevice.threshold_yellow > tempIAQDevice.threshold_red) {
			window.app.showToast(this.props.receiver.getString('lower_upper_error'), 3000);
			return;
		}

		if (tempPayload.hasOwnProperty(this.props.param.room_id)) {
			if (this.props.param.selected_iaq_settings_index == null) {																//add new record.
				tempPayload[this.props.param.room_id].push(tempIAQDevice);

				this.props.content_handler('Add_Edit_IAQ', { room_id: this.props.param.room_id, iaq_settings: tempPayload });
			} else {																												//edit previous exist record			
				if (tempPayload[this.props.param.room_id].hasOwnProperty(this.props.param.selected_iaq_settings_index)) {
					tempPayload[this.props.param.room_id].splice(this.props.param.selected_iaq_settings_index, 1, tempIAQDevice);

					this.props.content_handler('Add_Edit_IAQ', { room_id: this.props.param.room_id, iaq_settings: tempPayload });
				} else {
					//iaq device index does not exist
					window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
				}
			}
		} else {
			//room id does not exist
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	handleDelete = () => {
		let tempPayload = JSON.parse(JSON.stringify(this.props.param.iaq_settings));

		if (tempPayload.hasOwnProperty(this.props.param.room_id)) {
			if (tempPayload[this.props.param.room_id].hasOwnProperty(this.props.param.selected_iaq_settings_index)) {
				tempPayload[this.props.param.room_id].splice(this.props.param.selected_iaq_settings_index, 1);

				this.props.content_handler('Add_Edit_IAQ', { room_id: this.props.param.room_id, iaq_settings: tempPayload });
			} else {
				//iaq device index does not exist
				window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
			}
		} else {
			//room id does not exist
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	// Change Management point
	handleChangeMP = (point_id) => {
		let tempPayload = JSON.parse(JSON.stringify(this.state.selected_iaq_device));
		tempPayload.id = point_id;
		this.setState({ selected_iaq_device: tempPayload });

	}

	handleIAQTypeChange = (response) => {
		let tempPayload = JSON.parse(JSON.stringify(this.state.selected_iaq_device));
		tempPayload.type = response;
		this.setState({ selected_iaq_device: tempPayload });
	}

	handleThresholdYellowChange = (response) => {
		let tempPayload = JSON.parse(JSON.stringify(this.state.selected_iaq_device));

		if (!isNaN(response) && response != '') {
			if (parseInt(response) < 1000000) {
				tempPayload.threshold_yellow = parseInt(response);
			}
		} else {
			tempPayload.threshold_yellow = response;
		}

		this.setState({ selected_iaq_device: tempPayload });
	}

	handleThresholdRedChange = (response) => {
		let tempPayload = JSON.parse(JSON.stringify(this.state.selected_iaq_device));

		if (!isNaN(response) && response != '') {
			if (parseInt(response) < 1000000) {
				tempPayload.threshold_red = parseInt(response);
			}
		} else {
			tempPayload.threshold_red = response;
		}

		this.setState({ selected_iaq_device: tempPayload });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let styleSelection = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20
		}

		let main_content_style = {
			overflow: 'auto',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let dropdown_right_margin = (this.props.width - 200) / 2;

		const sensor_type = ['ac', 'dehumi', 'co2', 'pm25', 'tvoc', 'co', 'temp', 'humi'];
		const iaqTypeList = [];

		for (const iaqType of sensor_type) {
			if(iaqType != 'ac' && iaqType != 'dehumi') {
				if (this.state.selected_iaq_device.type == iaqType) {
					iaqTypeList.push(<option selected value={iaqType}>{this.props.receiver.getString(iaqType)}</option>);
				} else {
					iaqTypeList.push(<option value={iaqType}>{this.props.receiver.getString(iaqType)}</option>);
				}
			}
		}

		const mp_list = [];
		mp_list.push(<option value={''}>{this.props.receiver.getString('sel_device')}</option>)
		for (let point_id in window.app.state.point_list) {
			let can_select_management_point = true;
			let accessible_points = this.props.receiver.active_controller.auth.points; 					//list of points user has/has no access to
			if (this.props.receiver.active_controller.user_class != 'Admin') { 							//Admin class has access to all MP, so do not have to check
				can_select_management_point = false;
				if (accessible_points.hasOwnProperty(point_id)) {
					if (accessible_points[point_id]) {
						can_select_management_point = true;
					}
				}
			}

			//2nd check to prevent already selected devices from showing in the list of device
			if (can_select_management_point) {
				this.props.param.iaq_settings[this.props.param.room_id].forEach((existingDevice) => {	
					if( point_id == existingDevice.id && point_id != this.state.selected_iaq_device.id){
						can_select_management_point = false;
					}
				});
			}

			//if still true, show device in list
			if (can_select_management_point) {
				let mp_point_info = window.app.state.point_list[point_id];

				if (sensor_type.includes(mp_point_info.usage)) {
					mp_list.push(<option value={point_id}>{mp_point_info.name}</option>)
				}
			}
		}

		let yellow_label = 'caution';
		let red_label = 'warning';

		if (this.state.selected_iaq_device.type == 'temp' || this.state.selected_iaq_device.type == 'humi') {
			yellow_label = 'lower';
			red_label = 'upper';
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('iaq_devices')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div id='mp_list' style={{ marginLeft: 10, textAlign: 'center' }}>
						<div style={{ width: this.props.width - 20 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('choose_device')}</span>
						</div>
						<div style={{ width: this.props.width - 20 }}>
							<Select
								style={{ verticalAlign: 'top', }}
								select_style={{ fontSize: 20, height: 35 }}
								options={mp_list}
								value={this.state.selected_iaq_device.id}
								onSelect={this.handleChangeMP}
							/>
						</div>
					</div>

					<div id='data' style={{ height: this.props.height - 200, paddingBottom: 60, overflow: 'auto' }}>
						<div id='iaq_type' style={styleSelection}>
							<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 160 }}>
								<span>{this.props.receiver.getString('type')}</span>
							</div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', width: 110 }}>
								<Select
									options={iaqTypeList}
									value={this.state.selected_iaq_device.type}
									onSelect={this.handleIAQTypeChange}
								/>
							</div>
						</div>

						<div id='iaq_threshold_red' style={styleSelection}>
							<div style={{ display: 'inline-block', verticalAlign: 'bottom', marginTop: 2, marginLeft: 5, width: this.props.width - 160 }}>
								<span>{this.props.receiver.getString('threshold') + ': ' + this.props.receiver.getString(red_label)}</span>
							</div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', width: 110 }}>
								<Editbox
									id='threshold_red'
									inputStyle={{ marginTop: 0, minWidth: 'unset' }}
									inputType='number'
									onChange={(event) => this.handleThresholdRedChange(event.target.value)}
									value={this.state.selected_iaq_device.threshold_red}
								/>
							</div>
						</div>

						<div id='iaq_threshold_yellow' style={styleSelection}>
							<div style={{ display: 'inline-block', verticalAlign: 'bottom', marginTop: 2, marginLeft: 5, width: this.props.width - 160 }}>
								<span>{this.props.receiver.getString('threshold') + ': ' + this.props.receiver.getString(yellow_label)}</span>
							</div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', width: 110 }}>
								<Editbox
									id='threshold_yellow'
									inputStyle={{ marginTop: 0, minWidth: 'unset' }}
									inputType='number'
									onChange={(event) => this.handleThresholdYellowChange(event.target.value)}
									value={this.state.selected_iaq_device.threshold_yellow}
								/>
							</div>
						</div>

						{/* <div style={{display: 'block', padding: 20}}>
							IAQ ID: {this.state.selected_iaq_device.id}
						</div> */}

						{/* <div style={{display: 'block', padding: 20}}>
							IAQ Type: {this.state.selected_iaq_device.type}
						</div> */}

						{/* <div style={{display: 'block', padding: 20}}>
							Threshold Yellow: {this.state.selected_iaq_device.threshold_yellow}
						</div> */}

						{/* <div style={{display: 'block', padding: 20}}>
							Threshold Red: {this.state.selected_iaq_device.threshold_red}
						</div> */}
					</div>
				</div>
			</div>
		)
	}
}